//import I18n from "i18n-js/index.js.erb"

var BedroomBuilderErrors = {

  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    if (errors.code && errors.code.length) {
      for (var i = 0, ilen = errors.code.length; i < ilen; i++) {
        err.push(I18n.t('code') + ' ' + errors.code[i]);
      }
    }

    if (errors.name && errors.name.length) {
      for (var i = 0, ilen = errors.name.length; i < ilen; i++) {
        err.push(I18n.t('name') + ' ' + errors.name[i]);
      }
    }

    if (errors.description && errors.description.length) {
      for (var i = 0, ilen = errors.description.length; i < ilen; i++) {
        err.push(I18n.t('description') + ' ' + errors.description[i]);
      }
    }

    if (errors.composition_room && errors.composition_room.length) {
      for (var i = 0, ilen = errors.composition_room.length; i < ilen; i++) {
        err.push(I18n.t('composition_room') + ' ' + errors.composition_room[i]);
      }
    }

    if (errors.room_size && errors.room_size.length) {
      for (var i = 0, ilen = errors.room_size.length; i < ilen; i++) {
        err.push(I18n.t('room_size') + ' ' + errors.room_size[i]);
      }
    }

    if (errors.bed_type && errors.bed_type.length) {
      for (var i = 0, ilen = errors.bed_type.length; i < ilen; i++) {
        err.push(I18n.t('bed_type') + ' ' + errors.bed_type[i]);
      }
    }

    if (errors.amenities && errors.amenities.length) {
      for (var i = 0, ilen = errors.amenities.length; i < ilen; i++) {
        err.push(I18n.t('amenity') + ' ' + errors.amenities[i]);
      }
    }

    return err;
  },
};

export default BedroomBuilderErrors
